import React, { useEffect } from 'react';
import { useImmer } from 'use-immer';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import _ from 'lodash';
import { Button, Modal, Form, Col, Alert, ButtonGroup, ToggleButton } from 'react-bootstrap';
import FormControls, { ConditionalRender } from '../formControls';
import { EmrVendorService } from '../../services';

const queueValidation = Yup.object().shape({
    name: Yup.string().required('Vendor name is required.')
        .min(3, 'Vendor name must contain at least three characters.')
        .max(40, 'Vendor name must have less than 40 characters.')
});

const UpsertEmrVendorModal = (props) => {
    const [title, setTitle] = useImmer("");
    const [vendor, setVendor] = useImmer({ id: 0, name: "", state: 100 });
    const [error, setError] = useImmer("");

    useEffect(() => {
        if (props.model?.id > 0) {
            setTitle("Update Emr Vendor");
            getVendor(props.model.id);
        }
        else {
            setTitle("Create Emr Vendor");
        }
    }, [props.model])

    const getVendor = async (id) => {
        const vendorService = new EmrVendorService();
        var callResult = await vendorService.getVendor(id);
        if (callResult.result) {
            setVendor(callResult.model);
        }
    }

    const saveVendor = async (values) => {
        const service = new EmrVendorService();
        var results = await service.saveVendor(values);
        if (results.result) {
            props.updateVendors();
            setError("");
            // close the modal
            props.hideModal();
        }
        else {
            setError(results.errors[0]);
        }
    }

    const formik = useFormik({
        initialValues: vendor,
        validationSchema: queueValidation,
        enableReinitialize: true,
        onSubmit: async (values, { setSubmitting, setErrors, setStatus, resetForm }) => {
            var result = await saveVendor(values)
            if (!result.result) {
                setError(result.message);
            }
            setSubmitting(false);
        }
    });

    return (
        <>
            <Modal.Header>{title}</Modal.Header>
            <Modal.Body>
                <Form.Row>
                    <Alert variant='danger' show={error}>{error}</Alert>
                    <Form.Group as={Col} lg="12" md="12" controlId="name">
                        <FormControls.Textbox
                            name="name"
                            label="Vendor Name"
                            formHandler={formik} />
                    </Form.Group>
                </Form.Row>
                <ConditionalRender visible={vendor?.id > 0}>
                    <Form.Row>
                        <Form.Group as={Col} lg="12" md="12">
                            <FormControls.ButtonGrouping
                                label="State"
                                name="state"
                                size="sm"
                                variant="secondary"
                                formHandler={formik}
                                options={[{ value: 100, name: "Active" }, { value: -100, name: "Deleted" }]} />
                        </Form.Group>
                    </Form.Row>
                </ConditionalRender>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={props.hideModal}>Cancel</Button>
                <Button variant="primary" onClick={() => formik.submitForm()}>Save</Button>
            </Modal.Footer>
        </>
    );
}

export default UpsertEmrVendorModal;